import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingPromos } from '../../components/NewbuildingPromos';
import {
  getHasNewbuildingPromos,
  getIsFromBuilder,
  getIsFromSeller,
  getNewbuildingName,
} from '../../selectors/newObject';
import { Promos } from './parts/Promos';
import { PromosBanner } from './parts/PromosBanner';

export const NewbuildingPromosSectionContainer = ({ isRedesign }: { isRedesign: boolean }) => {
  const isFromBuilder = useSelector(getIsFromBuilder);
  const isFromSeller = useSelector(getIsFromSeller);
  const newbuildingName = useSelector(getNewbuildingName);
  const hasNewbuildingPromos = useSelector(getHasNewbuildingPromos);
  const newbuildingNameFormatted = newbuildingName.length > 0 ? ` «${newbuildingName}»` : '';

  if (!(isFromBuilder || isFromSeller)) {
    return null;
  }

  const PromosComponent = hasNewbuildingPromos ? Promos : undefined;

  return (
    <NewbuildingPromos
      Banner={PromosBanner}
      Promos={PromosComponent}
      withHeader={isRedesign}
      withBorder={!isRedesign}
      newbuildingName={newbuildingNameFormatted}
    />
  );
};

NewbuildingPromosSectionContainer.displayName = 'NewbuildingPromosSectionContainer';
